import { selectRootSliceFCCJ } from '../../Main/selectors';
import { ROOT_SLICE } from './constants';

const EMPTY_ARRAY = [];

export const selectThisSlice = state => {
	const appSlice = selectRootSliceFCCJ(state);
	return appSlice[ROOT_SLICE] || state;
};

export const selectData = state => {
	const slice = selectThisSlice(state);
	const { data } = slice;
	return data;
};

export const selectDataByCustomer = (state, { customer }) => {
	const data = selectData(state);
	return data[customer] || EMPTY_ARRAY;
};

export const selectIsLoadingIsLoaded = state => {
  const slice = selectThisSlice(state);
  const { isLoading, isLoaded } = slice;
  return { isLoading, isLoaded };
}

export const selectIsLoading = state => {
	const slice = selectThisSlice(state);
	const { isLoading } = slice;
	return isLoading;
};

export const selectIsLoaded = state => {
	const slice = selectThisSlice(state);
	const { isLoaded } = slice;
	return isLoaded;
};

export const selectErrorMessage = state => {
	const slice = selectThisSlice(state);
	const { errorMessage } = slice;
	return errorMessage;
};

export default {
	selectData,
	selectDataByCustomer,
  selectIsLoadingIsLoaded,
	selectIsLoading,
	selectIsLoaded,
	selectErrorMessage
};
